<template>
  <div class="finatrade_wrapper" v-if="editedItem">
    <div class="page page1">
      <div class="finatrade_header" style="text-align: center;">
        <h1>合迪股份有限公司交易申請書</h1>
      </div>
      <!--header-->
      <div class="top">
        <div class="top-car">車種：機車</div>
        <!--top-car-->
        <div class="top-name">
          進件單位：
          <span></span>
        </div>
        <div class="top-date">
          申請日期：
          <span class="y">{{editedItem ? editedItem.applyDate.year : ''}}</span>年
          <span class="m">{{editedItem ? editedItem.applyDate.month: ''}}</span>月
          <span class="d">{{editedItem ? editedItem.applyDate.day: ''}}</span>日
        </div>
      </div>
      <!--top-->
      <div class="area1">
        <div class="title1">
          申請
          <br />資訊
        </div>
        <table class="table1">
          <tr>
            <td rowspan="2" width="252px">
              <span class="tdTit tdTit1">金額：NT$</span>
              <div class="con1">{{editedItem.vendor.totalPrice}}</div>
              <span class="tdTit tdTit2">元整</span>
            </td>
            <td class="tdEnd tdDot">
              <span class="tdTit tdTit3">專案名稱</span>
              <div class="con2">{{editedItem.vendor.productName}}</div>
            </td>
          </tr>
          <tr>
            <td class="tdEnd">
              <span class="tdTit tdTit4">期數：</span>
              <div class="con3">{{editedItem.vendor.installmentsNumber}}</div>
              <span class="tdTit tdTit5">期</span>
              <span class="tdTit tdTit6">付款條件：</span>
              <div class="con4">
                <span class="checkbox">
                  <input type="checkbox" disabled />
                </span>單月付
                <span class="checkbox">
                  <input type="checkbox" disabled />
                </span>雙月付&nbsp;(&nbsp;期付款：NT$
                <span class="con4-0">{{editedItem.vendor.creditPriceMonth}}</span>元&nbsp;)
                <span class="checkbox con4-1">
                  <input type="checkbox" disabled />
                </span>其他
                <div class="con4-2"></div>
              </div>
            </td>
          </tr>
        </table>
        <!--table1-->
        <div class="title2">
          付款
          <br />方式
        </div>
        <table class="table2">
          <tr>
            <td width="205px">
              <div class="con5">
                <span class="checkbox">
                  <input type="checkbox" :checked="editedItem.paymentInfo.isBankBillPay" disabled />
                </span>銀行自動扣繳
                <span class="checkbox">
                  <input type="checkbox" style="margin-left:-3px;" :checked="editedItem.paymentInfo.isPostBillPay" disabled />
                </span>郵局
                <span class="checkbox">
                  <input type="checkbox" :checked="editedItem.paymentInfo.isAtmBillPay" disabled />
                </span>ATM
                <span class="checkbox">
                  <input type="checkbox" :checked="editedItem.paymentInfo.isStoreBillPay" disabled />
                </span>超商
                <span class="checkbox">
                  <input type="checkbox" :checked="editedItem.paymentInfo.isAutoBillPay" disabled />
                </span>ACH
              </div>
            </td>
            <td>
              <span class="tdTit tdTit7">繳款單寄送處：</span>
              <div class="con6">
                <span class="checkbox">
                  <input type="checkbox" :checked="editedItem.paymentInfo.debitNote.isRegistration" disabled />
                </span>戶籍地
                <span class="checkbox">
                  <input type="checkbox" :checked="editedItem.paymentInfo.debitNote.isMailingAddress" disabled />
                </span>通訊地
                <span class="checkbox">
                  <input type="checkbox" :checked="editedItem.paymentInfo.debitNote.isCompanyAddress" disabled />
                </span>公司
                <span class="checkbox">
                  <input type="checkbox" :checked="editedItem.paymentInfo.debitNote.isOtherAddress" disabled />
                </span>其他
                <div class="con6-1">{{editedItem.paymentInfo.debitNote.address}}</div>
              </div>
            </td>
          </tr>
        </table>
        <!--table2-->
        <table class="table3">
          <tr>
            <td width="50px">
              <div class="con7">
                <span class="checkbox">
                  <input type="checkbox" disabled />
                </span>支票付款
              </div>
            </td>
            <td width="175px">
              <span class="tdTit tdTit8">(付款行：</span>
              <div class="con8 con8-1">{{editedItem.bankName}}</div>
              <span class="tdTit tdTit9">銀行</span>
            </td>
            <td>
              <div class="con9 con9-1">{{editedItem.bankSubName}}</div>
              <span class="tdTit tdTit10">分行</span>
            </td>
          </tr>
        </table>
        <!--table3-->
        <table class="table4">
          <tr>
            <td width="195px">
              <span class="tdTit tdTit11">帳號：</span>
              <div class="con10 con10-1">{{editedItem.bankAccount}}</div>
            </td>
            <td width="210px">
              <span class="tdTit tdTit12">發票人：</span>
              <div class="con11 con11-1">{{editedItem.customer.name}}</div>
            </td>
            <td width="115px">
              <span class="tdTit tdTit13">發票日：</span>
              <div class="con12 con12-1"></div>
            </td>
            <td>
              <span class="tdTit tdTit14">往來情形：</span>
              <div class="con13">
                (
                <div class="con13-1"></div>)
              </div>
            </td>
          </tr>
        </table>
        <!--table4-->
        <div class="title3-1">手機</div>
        <table class="table5-1">
          <tr>
            <th width="192px"><span class="tdTit tdTit15-1">手機廠牌</span></th>
            <th width="182px"><span class="tdTit tdTit16-1">手機型號</span></th>
            <th class="thEnd"><span class="tdTit tdTit17-1">IMEI碼</span></th>
          </tr>
          <tr>
            <td>{{editedItem.phoneVendor}}</td>
            <td>{{editedItem.phoneModel}}</td>
            <td class="tdEnd">{{editedItem.phoneIMEI}}</td>
          </tr>
        </table>
        <div class="title3-2">車輛</div>
        <table class="table5-2">
          <tr>
            <th width="192px">
              <span class="tdTit tdTit15">廠牌</span>
            </th>
            <th width="182px">
              <span class="tdTit tdTit16">車型</span>
            </th>
            <th width="192px">
              <span class="tdTit tdTit17">車號</span>
            </th>
            <th class="thEnd">
              <span class="tdTit tdTit18">出廠年/月</span>
            </th>
          </tr>
          <tr>
            <td>{{editedItem.laonhfcInfo.vendor}}</td>
            <td>{{editedItem.laonhfcInfo.name}}</td>
            <td>{{editedItem.laonhfcInfo.carId}}</td>
            <td class="tdEnd">{{editedItem.laonhfcInfo.manufactureDate}}</td>
          </tr>
        </table>
        <!--table5-->
      </div>
      <!--area1-->
      <div class="area2">
        <div class="title1">申請人</div>
        <table class="table6">
          <tr>
            <td width="174px">
              <span class="tdTit tdTit19">姓名：</span>
              <div class="con14">{{editedItem.customer.name}}</div>
            </td>
            <td width="165px">
              <span class="tdTit tdTit20">身分證字號：</span>
              <div class="con15">{{editedItem.customer.memberId}}</div>
            </td>
            <td width="102px">
              <div class="con16">
                <span class="checkbox">
                  <input type="checkbox" :checked="editedItem.customer.married[0].value === true" disabled />
                </span>已婚
                <span class="checkbox">
                  <input type="checkbox" :checked="editedItem.customer.married[1].value === true" disabled />
                </span>未婚
              </div>
            </td>
            <td class="tdEnd" width="105px">
              <span class="tdTit tdTit21">生日：</span>
              <div class="con17">{{editedItem.customer.birthday}}</div>
            </td>
            <td class="tdBorder">
              <span class="tdTit tdTit22">視訊照會時間：</span>
              <div class="con18"></div>
            </td>
          </tr>
        </table>
        <!--table6-->
        <table class="table7">
          <tr>
            <td width="317px">
              <span class="tdTit tdTit23">戶籍地址：</span>
              <div class="con19">
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.customer.home.homeType1[0].value" disabled />
                </span>同身分證住址
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.customer.home.homeType1[1].value" disabled />
                </span>其他
                <div class="con19-1">{{getFullAddress}}</div>
              </div>
            </td>
            <td width="106px">
              <span class="tdTit tdTit24">電話：</span>
              <div class="con20">{{editedItem.customer.phone}}</div>
            </td>
            <td width="124px">
              <span class="tdTit tdTit25">行動電話：</span>
              <div class="con21">{{editedItem.customer.cellphone}}</div>
            </td>
            <td class="tdEnd">
              <span class="tdTit tdTit26">LINE&nbsp;&nbsp;&nbsp;ID：</span>
              <div class="con22"></div>
            </td>
          </tr>
        </table>
        <!--table7-->
        <table class="table8">
          <tr>
            <td width="420px" class="tdEnd">
              <span class="tdTit tdTit27">通訊地址：</span>
              <div class="con23">
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.customer.home.homeType2[0].value" disabled />
                </span>戶籍
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.customer.home.homeType1[1].value" disabled />
                </span>公司地
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.customer.home.homeType1[2].value" disabled />
                </span>其他
                <div class="con23-1">{{getFullContactAddress}}</div>
              </div>
            </td>
            <td width="174px">
              <span class="tdTit tdTit28">電話：</span>
              <div class="con24">{{editedItem.customer.homePhone}}</div>
            </td>
            <td class="tdEnd">
              <div class="con25">
                <span class="checkbox">
                  <input type="checkbox" disabled />
                </span>領有身心殘障手冊(&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)
                <div class="con25-1"></div>
              </div>
            </td>
          </tr>
        </table>
        <!--table8-->
        <table class="table9">
          <tr>
            <td width="375px">
              <span class="tdTit tdTit29">現居地住</span>
              <div class="con26-1">{{editedItem.customer.home.liveYear}}</div>
              <span class="tdTit tdTit30">年</span>
              <div class="con27">
                <span class="checkbox">
                  <input type="checkbox" :checked="editedItem.customer.home.liveLevel[0].value" disabled />
                </span>自有/配偶所有
                <span class="checkbox">
                  <input type="checkbox" :checked="editedItem.customer.home.liveLevel[2].value" disabled />
                </span>父母/子女所有
                <span class="checkbox">
                  <input type="checkbox" :checked="editedItem.customer.home.liveLevel[3].value" disabled />
                </span>租賃
                <span class="checkbox" style="margin-left:3px; margin-right:-3px;">
                  <input type="checkbox" :checked="editedItem.customer.home.liveLevel[4].value" disabled />
                </span>其他
                <div class="con27-1"></div>
              </div>
            </td>
            <td width="121px">
              <span class="tdTit tdTit31">任職公司：</span>
              <div class="con28">
                <div class="con28-1">{{editedItem.company.name}}</div>
              </div>
            </td>
            <td width="98px">
              <span class="tdTit tdTit32">職稱：</span>
              <div class="con29">
                <div class="con29-1">{{editedItem.company.title}}</div>
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit tdTit33">公司電話：</span>
              <div class="con30">{{editedItem.company.phone}}</div>
            </td>
          </tr>
        </table>
        <!--table9-->
        <table class="table10">
          <tr>
            <td width="133px">
              <span class="tdTit tdTit34">年收入&nbsp;&nbsp;NT$</span>
              <div class="con31">{{editedItem.company.yearSalary}}</div>
              <span class="tdTit tdTit35">萬</span>
            </td>
            <td width="59px">
              <span class="tdTit tdTit36">年資</span>
              <div class="con32">{{editedItem.company.workYear}}</div>
              <span class="tdTit tdTit37">年</span>
            </td>
            <td width="108px">
              <span class="tdTit tdTit38">學歷：</span>
              <div class="con33">{{editedItem.customer.education}}</div>
            </td>
            <td class="tdEnd">
              <span class="tdTit tdTit39">公司地址：</span>
              <div class="con34">{{editedItem.company.address}}</div>
            </td>
          </tr>
        </table>
        <!--table10-->
      </div>
      <!--area2-->
      <div class="area3">
        <div class="title1">連帶保證人</div>
        <table class="table11">
          <tr>
            <td width="140px">
              <span class="tdTit tdTit40">姓名：</span>
              <div class="con35">{{editedItem.jointGuarantor.name}}</div>
            </td>
            <td width="154px">
              <span class="tdTit tdTit41">身分證字號：</span>
              <div class="con36">{{editedItem.jointGuarantor.memberId}}</div>
            </td>
            <td width="92px">
              <div class="con37">
                <span class="checkbox">
                  <input type="checkbox" disabled />
                </span>已婚
                <span class="checkbox">
                  <input type="checkbox" disabled />
                </span>未婚
              </div>
            </td>
            <td width="90px">
              <span class="tdTit tdTit42">生日：</span>
              <div class="con38">{{editedItem.jointGuarantor.birthday}}</div>
            </td>
            <td width="69px" class="tdEnd">
              <span class="tdTit tdTit43">關係：</span>
              <div class="con39">{{editedItem.jointGuarantor.type}}</div>
            </td>
            <td class="tdBorder">
              <span class="tdTit tdTit44">視訊照會時間：</span>
              <div class="con40"></div>
            </td>
          </tr>
        </table>
        <!--table11-->
        <table class="table12">
          <tr>
            <td width="317px">
              <span class="tdTit tdTit45">戶籍地址：</span>
              <div class="con41">
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.jointGuarantor.home.homeType1[0].value" disabled />
                </span>同身分證住址
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.jointGuarantor.home.homeType1[1].value" disabled />
                </span>其他
                <div class="con41-1">{{editedItem.jointGuarantor.home.residenceAddress}}</div>
              </div>
            </td>
            <td width="106px">
              <span class="tdTit tdTit46">電話：</span>
              <div class="con42">{{editedItem.jointGuarantor.phone}}</div>
            </td>
            <td width="124px">
              <span class="tdTit tdTit47">行動電話：</span>
              <div class="con43">{{editedItem.jointGuarantor.cellphone}}</div>
            </td>
            <td class="tdEnd">
              <span class="tdTit tdTit48">LINE&nbsp;&nbsp;&nbsp;ID：</span>
              <div class="con44"></div>
            </td>
          </tr>
        </table>
        <!--table12-->
        <table class="table13">
          <tr>
            <td width="450px" class="tdEnd">
              <span class="tdTit tdTit49">通訊地址：</span>
              <div class="con45">
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.jointGuarantor.home.homeType2[0].value" disabled />
                </span>戶籍
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.jointGuarantor.home.homeType2[1].value" disabled />
                </span>公司地
                <span class="checkbox">
                  <input type="checkbox" v-model="editedItem.jointGuarantor.home.homeType2[2].value" disabled />
                </span>其他
                <div class="con45-1">{{editedItem.jointGuarantor.home.homeAddress1}}</div>
              </div>
            </td>
            <td width="134px">
              <span class="tdTit tdTit50">電話：</span>
              <div class="con46">{{editedItem.jointGuarantor.homePhone}}</div>
            </td>
            <td class="tdEnd">
              <div class="con47">
                <span class="checkbox">
                  <input type="checkbox" disabled />
                </span>領有身心殘障手冊(&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;)
                <div class="con47-1"></div>
              </div>
            </td>
          </tr>
        </table>
        <!--table13-->
        <table class="table14">
          <tr>
            <td width="339px">
              <span class="tdTit tdTit51">現居地住</span>
              <div class="con48">{{editedItem.jointGuarantor.home.liveYear2}}</div>
              <span class="tdTit tdTit52">年</span>
              <div class="con49">
                <span class="checkbox">
                  <input type="checkbox" :checked="editedItem.jointGuarantor.home.liveLevel2[0].value" disabled />
                </span>自有/配偶所有
                <span class="checkbox">
                  <input type="checkbox" :checked="editedItem.jointGuarantor.home.liveLevel2[2].value" disabled />
                </span>父母/子女所有
                <span class="checkbox">
                  <input type="checkbox" :checked="editedItem.jointGuarantor.home.liveLevel2[3].value" disabled />
                </span>租賃
                <span class="checkbox" style="margin-left:3px; margin-right:-3px;">
                  <input type="checkbox" :checked="editedItem.jointGuarantor.home.liveLevel2[5].value" disabled />
                </span>其他
                <div class="con49-1"></div>
              </div>
            </td>
            <td width="245px">
              <span class="tdTit tdTit53">學歷</span>
              <div class="con50">
                <span class="checkbox">
                  <input type="checkbox" :checked="editedItem.jointGuarantor.educationLevel ? editedItem.jointGuarantor.educationLevel[1].value : false" disabled />
                </span>研究所
                <span class="checkbox">
                  <input type="checkbox" :checked="editedItem.jointGuarantor.educationLevel ? editedItem.jointGuarantor.educationLevel[2].value: false" disabled />
                </span>大學&nbsp;/&nbsp;大專
                <span class="checkbox">
                  <input type="checkbox" :checked="editedItem.jointGuarantor.educationLevel ? editedItem.jointGuarantor.educationLevel[4].value: false" disabled />
                </span>高中職
                <span class="checkbox">
                  <input type="checkbox" :checked="editedItem.jointGuarantor.educationLevel? editedItem.jointGuarantor.educationLevel[5].value: false" disabled />
                </span>初中及以下
              </div>
            </td>
            <td width="99px">
              <span class="tdTit tdTit54">年收入&nbsp;NT$</span>
              <div class="con51"></div>
              <span class="tdTit tdTit55">萬</span>
            </td>
            <td class="tdEnd">
              <span class="tdTit tdTit56">年資</span>
              <div class="con52"></div>
              <span class="tdTit tdTit57">年</span>
            </td>
          </tr>
        </table>
        <!--table14-->
        <table class="table15">
          <tr>
            <td width="152px">
              <span class="tdTit tdTit58">任職公司：</span>
              <div class="con53">
                <div class="con53-1">{{editedItem.jointGuarantor.companyName}}</div>
              </div>
            </td>
            <td width="108px">
              <span class="tdTit tdTit59">職稱：</span>
              <div class="con54">
                <div class="con54-1">{{editedItem.jointGuarantor.title}}</div>
              </div>
            </td>
            <td width="345px" class="tdEnd">
              <span class="tdTit tdTit60">公司地址：</span>
              <div class="con55">
                <div class="con55-1">{{editedItem.jointGuarantor.companyAddress}}</div>
              </div>
            </td>
            <td class="tdEnd">
              <span class="tdTit tdTit61">電話：</span>
              <div class="con56">{{editedItem.jointGuarantor.companyPhone}}</div>
            </td>
          </tr>
        </table>
        <!--table15-->
      </div>
      <!--area3-->
      <div class="area4">
        <div class="title1">聲明事項暨同意事項</div>
        <div class="ulBox">
          <ul class="list">
            <li>
              <b>
                <u>辦理本專案所檢附之申請文件及申請表格(含本申請書)與同意先行簽署用印本契約及相關之債權文件，如因故無法通過貴公司之審核或已核准後，申請人未與貴公司往來者，申請人及連帶保證人等同意貴公司無須返還相關文件。</u>
              </b>
            </li>
            <li>申請人等知悉本專案可由貴公司委託之公司或人員處理有關本專案之申請作業，惟未透過其他代辦公司辦理。除買賣合約所載費用外，無其他人員向申請人等收取額外費用或報酬。</li>
            <li>
              <b>
                <u>申請人等知悉貴公司保留核准本專案與否及最終交易金額、期間等各項條件之權利。申請人知悉並同意支付經銷商手續費作為本專案核准後車輛動產抵押規費及設定服務費用。</u>
              </b>
            </li>
            <li>申請人等同意因保全本債權所生之費用(含占有抵押標的物)、訴訟費用及所受之損失，概由申請人等負擔。</li>
            <li>
              <b>個人資料保護法告知事項:</b>
            </li>
          </ul>
        </div>
        <!--ulBox-->
        <p class="p1">
          合迪股份有限公司(以下稱本公司)依據個人資料保護法(以下稱個資法)規定，向申請人告知下列事項，請 申請人詳閱:(1)蒐集之目的:(一)辦理本公司經 營合於營業登記項目或組織章程所定之業務(包括但不限於租賃、分期付款買賣、資金貸與、應收帳款受讓暨管理等相關業務);(二)契約、類似契約或其他法 律關係事務;核貸與授信業務;帳務管理及債權交易業務;授信業務;債權整貼現及收買業務;徵信業務(包括但不限於產業上下游及同業間彼此照會、租賃同 業、關係企業、票信等照會之徵信行為);(三)調查、統計與研究分析(包括但不限於財團法人資訊工業策進會等研究分析機構);(四)消費者管理、客戶管理與 服務、消費者保護;(五)資(通)訊服務、資(通)訊與資料庫管理、資通安全與管理;及(六)行銷(包括但不限於本公司及其母公司中租控股股份有限公司暨其 子(孫)公司及其業務委外機構等，於行銷或合作目的之範圍內使用等)。蒐集之個人資料類別:依個人資料保護法第二條第一項所定義之個人資料，包含識別類 (包括但不限於姓名、國民身分證統一編號及聯絡方式)、特徵類、家庭情形、社會情況、教育、考選、技術或其他專業、受僱情形、財務細節(包括但不限於個人 所得資料、財產資料、綜合所得稅及房地合一稅繳納、欠稅及退稅紀錄等財務相關之資料)、保險資料(包括但不限於個人投保及退保資料、勞工保險被保險人投 保資料等保險有關之資料)、商業資訊(包括與本公司相關業務之申請書或契約書內容及其他具有正當合理關聯之紀錄)，但仍以本公司與申請人往來之相關業務 所實際蒐集之個人資料為準。(2)個人資料利用之期間、對象、地區及方式:
          <b>
            <u>期間</u>
          </b>：個人資料蒐集之特定目的存續期間、依相關法令或契約約定之保存期限(如: 商業會計法等)或本公司因執行業務所必須之保存期間。
          <b>
            <u>對象</u>
          </b>：本公司、本公司之關係企業及其母公司中租控股股份有限公司暨其子公司、財團法人金融聯合 徵信中心、票據交換所、財金資訊公司、代理收付款項業務機構、業務委外機構、未受中央目的事業主管機關限制之個人資料之接收者、本公司之共同行銷或交 互運用客戶之機構、本公司合作推廣對象、與本公司有業務往來之機構、依法有調查權機關或金融監理機關或其他法令得蒐集、處理及利用資料之人。
          <b>
            <u>申請人 並同意本公司得基於徵信之需要而代理申請人並使用申請人之個人資料暨銀行資料向發卡銀行及電信公司等為相關查詢。若申請人自行向財團法人金融聯合徵 信中心申請查詢並調閱取得信用報告後，或由您自行於個人化資料自主運用平台調閱並取得相關資料，申請人再自行將信用報告及其他調閱並取得之資料交付 本公司時，申請人同意本公司得以在與申請人業務往來或申請人所保證之主債務人往來評估範圍內利用申請人所交付前揭報告資料</u>
          </b>。地區:前揭利用對象之營 業處所所在地及未受中央目的事業主管機關限制之個人資料之接收者所在地。方式:以自動化機器或其他非自動化方式之利用方式(例如使用電子文件、紙本或 其他合於當時科技之適當方式)或符合個人資料保護法第20條規定之利用。申請人得透過書面或本公司同意之其他方式，依據個資法第三條規定，就本公司保有 申請人之個人資料申請行使下列權利:得向本公司查詢、請求閱覽或請求製給複製本，而本公司依法得酌收必要成本費用。得向本公司請求補充或更正，惟依 法申請人應為適當之釋明。得向本公司請求停止蒐集、處理或利用及請求刪除，惟依法本公司因執行業務所必須者，得不依申請人請求為之。申請人得自由選 擇是否提供相關個人資料，惟申請人若拒絕提供相關個人資料，本公司將無法進行必要之審核及處理作業，致無法提供申請人完善之相關業務或服務。
          <br/>
          <b>
            6.企業社會責任/個人社會責任同意事項
          </b>
          <br/>
          台端茲同意響應聯合國永續發展目標，在追求成長過程中同時兼顧永續發展、公司治理並落實企業社會責任/個人社會責任，並隨時檢討實施成效及持續改進。 倘行為違反前開約定，致使對於環境保護或社會公益造成危害，台端同意配合主管機關之要求於期限內進行改善，且願將改善情形提供予貴公司追蹤審查。
        </p>
        <p
          class="p2"
        >=======================================================================================</p>
        <p class="p3">
          <b>
            上述聲明及告知事項申請人已清楚明瞭其內容無誤知悉貴公司蒐集、處理或利用申請人個人資料之目的及用途，申請人並同意貴公司在上開告知事項範圍內，
            <u>得蒐集、處理或利用申請人之個人資料，且申請人提供與貴公司之資料若包含申請人以外第三人之個人資料時，申請人已以適當方式使該第三人知悉其個人資 料會提供與貴公司於本同意書範圍內，進行蒐集、處理或利用，另亦同意企業社會責任/個人社會責任同意事項</u>。
          </b>
        </p>
        <p class="p4">
          此致
          <br />
          <span>合迪股份有限公司</span>
        </p>
        <span class="sign1">申請人簽章</span>
        <img
            class="signbox"
            :src="signImageSrc('customer')"
          />
        <span class="sign2">連帶保證人簽章</span>
        <img
            class="signbox"
            :src="signImageSrc('jointGuarantor')"
          />
        <div class="line"></div>
      </div>
      <!--area4-->
      <span class="ps">機車及手機專用&nbsp;小車&nbsp;AR(原)2023.07</span>
    </div>
    <!--page1-->
  </div>
  <!--wrapper-->
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import common from '@/mixins/common';

export default {
  props: {
    item: Object,
  },
  name: "FinatradePrint",
  data() {
    return {};
  },
  mixins:[common],
  created() {
  },
  watch:{
    item(value){
      this.item.customer.education = this.getEducation(value.customer);
    }
  },
  computed: {
    editedItem() {
      return this.item;
    },
    getFullAddress(){
      if (this.editedItem){
        if (this.editedItem.customer.home.residencePost && this.editedItem.customer.home.residenceCity && this.editedItem.customer.home.residenceArea){
          return `${this.editedItem.customer.home.residencePost}${this.editedItem.customer.home.residenceCity}${this.editedItem.customer.home.residenceArea}${this.editedItem.customer.home.residenceAddress}`
        }
        return `${this.editedItem.customer.home.residenceAddress}`
      }
      return '';
    },
    getFullContactAddress(){
      if (this.editedItem){
        if (this.editedItem.customer.home.homePost && this.editedItem.customer.home.homeCity && this.editedItem.customer.home.homeArea){
          return `${this.editedItem.customer.home.homePost}${this.editedItem.customer.home.homeCity}${this.editedItem.customer.home.homeArea}${this.editedItem.customer.home.homeAddress1}`
        }
        return `${this.editedItem.customer.home.homeAddress1}`
      }
      return '';
    }
    // getManufactureDate() {
    //   if (!this.editedItem.laonhfcInfo.publicYear && !this.editedItem.laonhfcInfo.publicMonth) {
    //     return ''
    //   }
    //   const publicYear = this.editedItem.laonhfcInfo.publicYear;
    //   return `${publicYear}/${this.editedItem.laonhfcInfo.publicMonth}`
    // },
    // getYearSalary() {
    //   console.log(`getYearSalary ${this.editedItem.company.yearSalary}`)
    //   return parseInt(this.editedItem.company.salary * 12) / 10000
    // }
  },
  methods: {
    signImageSrc(itemPath) {
      let source = null;
      if (itemPath === "customer") {
        if (this.editedItem.signImage0) {
          source = this.editedItem.signImage0;
        } else if (this.editedItem.signimage0Url) {
          source = this.editedItem.signimage0Url;
        }
      } else if (itemPath === "jointGuarantor") {
        if (this.editedItem.signImage3) {
          source = this.editedItem.signImage3;
        } else if (this.editedItem.signimage3Url) {
          source = this.editedItem.signimage3Url;
        }
      }
      return source;
    },
    // getCaseProduct(item) {
    //         if (item.productId === '0') {
    //           return '機車原融';
    //         }
    //         if (item.productId === '1') {
    //           return '借新還舊';
    //         }
    //         if (item.productId === '2') {
    //           return '他行代償';
    //   }
    //   return '機車原融';
    // },
  }
};
</script>

<style scoped>
.page1 .top-name span,
.page1 .top .top-date span,
.page1 .con1,
.page1 .con2,
.page1 .con3,
.page1 .con4 .con4-2,
.page1 .con6 .con6-1,
.page1 .con8-1,
.page1 .con9-1,
.page1 .con10-1,
.page1 .con11-1,
.page1 .table5 tr td,
.page1 .con14,
.page1 .con15,
.page1 .con17,
.page1 .con18,
.page1 .con20,
.page1 .con21,
.page1 .con22,
.page1 .con23-1,
.page1 .con24,
.page1 .con25-1,
.page1 .con26-1,
.page1 .con30,
.page1 .con31,
.page1 .con32,
.page1 .con33,
.page1 .con34,
.page1 .con35,
.page1 .con36,
.page1 .con38,
.page1 .con39,
.page1 .con40,
.page1 .con41-1,
.page1 .con42,
.page1 .con43,
.page1 .con44,
.page1 .con45-1,
.page1 .con46,
.page1 .con47-1,
.page1 .con48,
.page1 .con49-1,
.page1 .con51,
.page1 .con52,
.page1 .con53-1,
.page1 .con54-1,
.page1 .con55-1,
.page1 .con56 {
  color: #0505da;
}
.signbox {
  position: absolute;
  margin-left:10px;
  width: 125px; height: 30px;
}
</style>

<style scoped src="../../assets/css/finatrade_print.css">
</style>



// WEBPACK FOOTER //
// src/pages/web/FinatradePrint.vue